import { Component, OnInit, Input, ViewChild } from '@angular/core';
import {DialogRef, DialogService} from '@progress/kendo-angular-dialog';
import {FormGroup, FormBuilder, AbstractControl} from '@angular/forms';
import { FormService } from '../../../fw/services/form.service';
import { ValidationMessageComponent } from '../../shared/validation-message.component';
import { SharedValidators } from '../../shared/shared-validators';
import { SharedService } from '../../shared/shared.service';
import { AutoUnsubscribe } from '../../../fw/decoractors/AutoUnsubscribe';
import {SettingsPlannerService} from "./settings-planner.service";
import {DtoAppointmentKind} from "./models/DtoAppointmentKind";
import {Observable} from "rxjs/Observable";
import {AsyncValidatorWrapper} from "../../../fw/helpers/async-validator-wrapper";
import {DtoAppointmentKindBaseItems} from "./models/DtoAppointmentKindBaseItems";
import {DynamicGridComponent} from "../../../fw/dynamic-grids/dynamic-grid.component";
import {PageSubheaderBarConfig} from "../../../fw/pages/page-config-api";
import {ColumnDefinition} from "../../../fw/dynamic-grids/column-definition";
import {DtoAppointmentKindForCombi} from "./models/DtoAppointmentKindForCombi";
import {AppointmentkindSelectCombiComponent} from "./appointmentkind-select-combi.component";
import {DtoAppointmentKindCombination} from "./models/DtoAppointmentKindCombination";

@Component({
    selector: 'appointmentkind-combination',
    template: require('./appointmentkind-combination.component.html'),
    styles: [require('./appointmentkind-combination.component.css')]
})
@AutoUnsubscribe()

export class AppointmentkindCombinationComponent implements OnInit {
    @Input() dialog: DialogRef;
    @Input() id: number;
    @Input() copyFromId: number;
    @ViewChild('validationMessage', {static: false}) validationMessage: ValidationMessageComponent;
    @ViewChild('gridCombiAppointments', {static: false}) gridCombiAppointments: DynamicGridComponent;
    form: FormGroup;
    dtoObject: DtoAppointmentKind;
    activeItems: Array<{ text: string, value: boolean }> = [
        { text: "Ja", value: true },
        { text: "Nee", value: false }
    ];
    baseItems: DtoAppointmentKindBaseItems;
    appointmentsForCombi: DtoAppointmentKindForCombi[];
    combiAppointmentConfig: PageSubheaderBarConfig = {
        title: 'BEHANDELINGEN',
        buttonDefinition: [
            {
                description: 'TOEVOEGEN',
                isSmall: true,
                clickEventType: 'create'
            },
            {
                description: 'VERWIJDEREN',
                isSmall: true,
                clickEventType: 'delete'
            }
        ]
    };
    combiAppointmentColumnDefinition: ColumnDefinition[] = [
        {
            key: 'index',
            label: 'Volgnummer',
            type: 'string',
            width: '140px'
        },
        {
            key: 'description',
            label: 'Omschrijving',
            type: 'string',
            width: '*'
        },
        {
            key: 'duration',
            label: 'Tijd behandeling',
            type: 'number',
            width: '140px'
        },
        {
            key: 'extension',
            label: 'Tijd doorboeken',
            type: 'number',
            width: '140px'
        }
    ];

    constructor(private fb: FormBuilder,
                private fs: FormService,
                private ds: SettingsPlannerService,
                private ss: SharedService,
                private dialogService: DialogService) { }

    ngOnInit() {
        this.ds.getAppointmentKindsForCombi().subscribe((res: DtoAppointmentKindForCombi[]) => {
           this.appointmentsForCombi = res;
        });

        this.form = this.fb.group({
            description: [null, [SharedValidators.customRequired]],
            onlineBookingDescription: null,
            showInAgenda: null,
            showInOnlineAgenda: null,
            index: [null,[SharedValidators.customRequired], [AsyncValidatorWrapper.debounce(this.validateIndex.bind(this))]],
            recActive: null,
            genderId: null,
            maxAtOnce: null
        });

        this.form.valueChanges.subscribe(() =>
            {if (this.validationMessage) this.validationMessage.getFormValidationErrors();}
        );

        if (this.id > 0) {
            this.ds.getAppointmentKindById(this.id)
                .subscribe(response => {
                    this.getBaseItems();
                    this.dtoObject = response;
                    this.fs.patchDtoToForm(this.dtoObject, this.form);
                    this.gridCombiAppointments.showData(this.dtoObject.appointmentKindCombinations);
                });
        }
        else {
            this.ds.getAppoinmentKindNextIndex()
                .subscribe(res => {
                    this.dtoObject = {
                        id: 0,
                        recActive: true,
                        index: res,
                        genderId: 0,
                        maxAtOnce: 0,
                        showInAgenda: true,
                        showInOnlineAgenda: true,
                        appointmentKindCombinations: []
                    };
                    this.getBaseItems();
                    if (this.copyFromId > 0) {
                        this.ds.getAppointmentKindById(this.copyFromId)
                            .subscribe(response => {
                                this.dtoObject.showInAgenda = response.showInAgenda;
                                this.dtoObject.showInOnlineAgenda = response.showInOnlineAgenda;
                                this.dtoObject.duration = response.duration;
                                this.dtoObject.extension = response.extension;
                                this.dtoObject.appointmentLabelId = response.appointmentLabelId;

                                for(let i = 0; i < response.appointmentKindCombinations.length; i++) {
                                    this.dtoObject.appointmentKindCombinations.push({
                                        id: 0,
                                        description: response.appointmentKindCombinations[i].description,
                                        index: response.appointmentKindCombinations[i].index,
                                        appointmentKindId1: response.appointmentKindCombinations[i].appointmentKindId1,
                                        extension: response.appointmentKindCombinations[i].extension,
                                        duration: response.appointmentKindCombinations[i].duration
                                    });
                                }

                                this.fs.patchDtoToForm(this.dtoObject, this.form);
                                this.gridCombiAppointments.showData(this.dtoObject.appointmentKindCombinations);
                            });
                    }
                    else {
                        this.fs.patchDtoToForm(this.dtoObject, this.form);
                    }
                });
        }
    }

    getBaseItems() {
        this.ds.getAppointmentKindBaseItems(false).subscribe(response => {
            this.baseItems = response;
        });
    }

    validateIndex(control: AbstractControl) {
        return Observable.create(observer => {
            if (this.dtoObject != null && control.dirty && control.value != null) {
                this.ds.checkAppoinmentKindIndexAvailable(this.dtoObject.id, control.value)
                    .subscribe((response: boolean) => {
                        observer.next(response ? null : { indexNotAvailable: true });
                        observer.complete();
                        if (this.validationMessage) this.validationMessage.getFormValidationErrors();
                    });
            }
            else {
                observer.next(null);
                observer.complete();
                if (this.validationMessage) this.validationMessage.getFormValidationErrors();
            }
        });
    }

    validateCombi() {
        if (this.dtoObject.appointmentKindCombinations.length == 0) {
            this.ss.message('Een combinatiebehandeling moet minimaal 1 onderdeel bevatten');
            return false;
        }
        return true;
    }

    btnCombiAppointmentBarClicked(event) {
        if (event == 'create') {
            this.showAppointmentCombiSearchWindow();
        } else if (event == 'delete' && this.gridCombiAppointments.getSelectedItem()) {
            this.dtoObject.appointmentKindCombinations.splice(this.dtoObject.appointmentKindCombinations.indexOf(this.gridCombiAppointments.getSelectedItem()), 1);
            let indexCounter = 1;
            this.dtoObject.appointmentKindCombinations.forEach((item) => {
                item.index = indexCounter;
                indexCounter++;
            });
            this.gridCombiAppointments.showData(this.dtoObject.appointmentKindCombinations);
            this.calculateTotalTimes();
        }
    }

    showAppointmentCombiSearchWindow() {
        if (this.appointmentsForCombi) {
            const dialogRef = this.dialogService.open({
                content: AppointmentkindSelectCombiComponent
            });

            const dialogContent: AppointmentkindSelectCombiComponent = dialogRef.content.instance;
            dialogContent.dialog = dialogRef;
            dialogContent.allAppointmentKinds = this.appointmentsForCombi;
            dialogContent.chosenAppointmentKinds = this.dtoObject.appointmentKindCombinations;
            dialogContent.combiSaved
                .subscribe((res: DtoAppointmentKindCombination) => {
                    this.dtoObject.appointmentKindCombinations.push(res);
                    this.gridCombiAppointments.showData(this.dtoObject.appointmentKindCombinations);
                    this.calculateTotalTimes();
                });
        }
    }

    calculateTotalTimes() {
        this.dtoObject.duration = 0;
        this.dtoObject.extension = 0;

        this.dtoObject.appointmentKindCombinations.forEach((item) => {
            this.dtoObject.duration += item.duration;
            this.dtoObject.extension += item.extension;
        });
    }

    btnCancelClicked(event) {
        this.closeWindow(false);
    }

    btnSaveClicked(event) {
        this.validationMessage.validateForm();

        if (this.form.valid && this.validateCombi()) {
            let result = this.fs.patchFormToDto(this.dtoObject, this.form);
            this.ds.saveAppointmentKind(result)
                .subscribe(response => {
                    if (!response.hasError) {
                        this.closeWindow(true);
                    }
                    else {
                        this.ss.message(response.errorMessage);
                    }
                });
        }
    }

    closeWindow(result: boolean) {
        if (this.dialog) {
            this.dialog.dialog.instance.action.emit(result);
            this.dialog.close();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/settings/settings-planner/appointmentkind-combination.component.ts